const sunyEmails = new Set([
    "acsu.buffalo.edu",
    "albany.edu",
    "alfred.edu",
    "alfredstate.edu",
    "binghamton.edu",
    "bnl.gov",
    "brockport.edu",
    "buffalo.edu",
    "buffalostate.edu",
    "canton.edu",
    "cayuga-cc.edu",
    "cihva.org",
    "clinton.edu",
    "cobleskill.edu",
    "corning-cc.edu",
    "cortland.edu",
    "delhi.edu",
    "downstate.edu",
    "esc.edu",
    "esf.edu",
    "exchange.fitnyc.edu",
    "farmingdale.edu",
    "fitnyc.edu",
    "flcc.edu",
    "fredonia.edu",
    "genesee.edu",
    "geneseo.edu",
    "herkimer.edu",
    "holyfamily.edu",
    "hvcc.edu",
    "lewisu.edu",
    "mail.suffolk.edu", "mail.sunnysuffolk.edu", "suffolk.edu", "sunnysussolk.edu",
    "mcphs.edu",
    "monroecc.edu",
    "monroecollege.edu",
    "morrisville.edu",
    "mvcc.edu",
    "ncc.edu",
    "nccc.edu",
    "newpaltz.edu",
    "northeasternbus.com",
    "oldwestbury.edu",
    "oneonta.edu",
    "oswego.edu",
    "pierce.ctc.edu",
    "plattsburgh.edu",
    "potsdam.edu",
    "purchase.edu",
    "snyoneva.cc.oneonta.edu",
    "stateuniversityofny.com",
    "stonybrook.edu",
    "stu.lemoyne.edu",
    "uamail.albany.edu",
    "upstate.edu",
    "wcupa.edu",
    "liveit.earth",
    "d2l.com"
]);

export function isSUNY( email ) {
    let domain = email.replace(/.*@/, "");

    return sunyEmails.has(domain) || email.match(/.*@.*\.edu/);
}

const teloEmails = new Set([
    "tdsb.on.ca",
    "peelsb.com",
    "yrdsb.ca",
    "tcdsb.org",
    "dpcdsb.org",
    "tvdsb.ca",
    "ocdsb.ca",
    "ddsb.ca",
    "hdsb.ca",
    "wrdsb.ca",
    "ycdsb.ca",
    "scdsb.on.ca",
    "ocsb.ca",
    "dsbn.org",
    "publicboard.ca",
    "hcdsb.org",
    "ugdsb.on.ca",
    "kprdsb.ca",
    "hwdsb.on.ca",
    "hwcdsb.ca",
    "ucdsb.on.ca",
    "granderie.ca",
    "wcdsb.ca",
    "smcdsb.on.ca",
    "lkdsb.net",
    "dcdsb.ca",
    "ncdsb.com",
    "ldcsb.ca",
    "wecdsb.on.ca",
    "limestone.on.ca",
    "bwdsb.on.ca",
    "tldsb.on.ca",
    "pvnccdsb.on.ca",
    "ed.amdsb.ca",
    "hpedsb.on.ca",
    "cdsbeo.on.ca",
    "rainbowschools.ca",
    "alcdsb.on.ca",
    "bhncdsb.ca",
    "nearnorthschools.ca",
    "rcdsb.on.ca",
    "adsb.ca",
    "sccdsb.net",
    "lakeheadschools.ca",
    "wellingtoncdsb.ca",
    "tbcschools.ca",
    "dsb1.ca",
    "sudburycatholicschools.ca",
    "kpdsb.ca",
    "rccdsb.edu.on.ca",
    "hpcdsb.ca",
    "hscdsb.on.ca",
    "bgcdsb.org",
    "ncdsb.on.ca",
    "npsc.ca",
    "rrdsb.com",
    "tncdsb.on.ca",
    "kcdsb.on.ca",
    "sgdsb.on.ca",
    "sncdsb.on.ca",
    "maranathachristian.ca",
    "d2l.com",
    "brightspace.com",
    "desire2learn.com"
]);


export function isTELO( email ) {
    let domain = email.replace(/.*@/, "");

    return teloEmails.has(domain);
}

const d2lEmails = new Set([
  "d2l.com",
  "desire2learn.ca"
]);

export function isD2L( email ) {
  let domain = email.replace(/.*@/, "");

  return d2lEmails.has(domain);
}



// WEBPACK FOOTER //
// ./src/components/data/email-domains.js